import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTdbank = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 47,
			height: 23,
			rx: 7.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 47,
			height: 23,
			rx: 7.5,
			stroke: "#E7E7E7"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4662_2244)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16 18H30.8571V5H16V18Z",
					fill: "#54B948"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_4662_2244",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 16,
					y: 5,
					width: 15,
					height: 13,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M16 18H30.8571V5H16V18Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask0_4662_2244)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M25.7537 15.1877H22.2932V9.08834H24.0313V14.1073H25.7031C26.8571 14.1073 27.3418 13.3251 27.3418 11.3109C27.3418 9.28454 26.7911 8.69569 25.6196 8.69569H21.807V15.1877H20.0858V8.69569H17.5601V7.61284H26.1558C28.2291 7.61284 29.214 8.66247 29.214 11.2947C29.214 14.7626 27.7434 15.1877 25.7537 15.1877Z",
						fill: "white"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4662_2244",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 15,
				height: 13,
				fill: "white",
				transform: "translate(16 5)"
			})
		}) })
	]
});
export default SvgTdbank;
